import { createContext } from 'react';
import noop from 'lodash/noop';

export const ModalContext = createContext<
  () => {
    container: HTMLDivElement | undefined;
    removeContainer: () => void;
  }
>(() => ({ container: undefined, removeContainer: noop }));
